<div class="image-section" [class.loading]="loading" [ngClass]="layout">
    @for (adBanner of banners; track adBanner) { @if (adBanner.banner) {
    <div
        class="image-box"
        (click)="openExternalUrl(adBanner.externalUrl, adBanner.source ?? '')"
        porAddFeature
        featureName="ad-image-`adBanner.banner`"
        [style.cursor]="adBanner.externalUrl ? 'pointer' : 'default'">
        <img [src]="adBanner.banner" alt="" />
    </div>
    } }
</div>
